import { TOGGLE_SIDEBAR } from "../constants/options";

export const toggleSidebar = () => ({
  type: TOGGLE_SIDEBAR
});
